exports.default = {
  scale: {
    gray: {
      "100": "#ebecf0",
      "200": "#dfe1e6",
      "300": "#c1c7d0",
      "400": "#8993a4",
      "500": "#6b778c",
      "600": "#57606a",
      "700": "#424a53",
      "800": "#32383f",
      "900": "#24292f",
      "000": "#fafbfc",
    },
    neutral: {
      "100": "#f7f8f9",
      "200": "#f1f2f4",
      "300": "#dcdfe4",
      "400": "#b3b9c4",
      "500": "#8590a2",
      "600": "#758195",
      "700": "#626f86",
      "800": "#44546f",
      "900": "#2c3e5d",
      "1000": "#172b4d",
      "1100": "#091e42",
      "000": "#ffffff",
    },
    neutralAlpha: {
      "100": "#091e4208",
      "200": "#091e420f",
      "300": "#091e4224",
      "400": "#091e4224",
      "500": "#091e427d",
      "000": "#ffffff00",
    },
    blue: {
      "100": "#cce0ff",
      "200": "#85b8ff",
      "300": "#579dff",
      "400": "#388bff",
      "500": "#1d7afc",
      "600": "#0c66e4",
      "700": "#0055cc",
      "800": "#09326c",
      "900": "#092957",
      "000": "#e9f2ff",
    },
    teal: {
      "100": "#c1f0f5",
      "200": "#8bdbe5",
      "300": "#60c6d2",
      "400": "#37b4c3",
      "500": "#1d9aaa",
      "600": "#1d7f8c",
      "700": "#206b74",
      "800": "#1d474c",
      "900": "#153337",
      "000": "#e3fafc",
    },
    purple: {
      "100": "#dfd8fd",
      "200": "#b8acf6",
      "300": "#9f8fef",
      "400": "#8f7ee7",
      "500": "#8270db",
      "600": "#6e5dc6",
      "700": "#5e4db2",
      "800": "#352c63",
      "900": "#15373b",
      "000": "#f3f0ff",
    },
    green: {
      "100": "#baf3db",
      "200": "#7ee2b8",
      "300": "#4bce97",
      "400": "#2abb7f",
      "500": "#22a06b",
      "600": "#1f845a",
      "700": "#216e4e",
      "800": "#164b35",
      "900": "#143c2b",
      "000": "#dffcf0",
    },
    yellow: {
      "100": "#f8e6a0",
      "200": "#f5cd47",
      "300": "#e2b203",
      "400": "#cf9f02",
      "500": "#b38600",
      "600": "#946f00",
      "700": "#7f5f01",
      "800": "#533f04",
      "900": "#3f3102",
      "000": "#fff7d6",
    },
    red: {
      "100": "#ffd2cc",
      "200": "#ff9c8f",
      "300": "#f87462",
      "400": "#ef5c48",
      "500": "#e34935",
      "600": "#ca3521",
      "700": "#ae2a19",
      "800": "#601e16",
      "900": "#4f1c16",
      "000": "#ffedeb",
    },
    orange: {
      "100": "#ffe2bd",
      "200": "#fec57b",
      "300": "#faa53d",
      "400": "#f18d13",
      "500": "#d97008",
      "600": "#b65c02",
      "700": "#974f0c",
      "800": "#5f3811",
      "900": "#4a2b0f",
      "000": "#fff4e5",
    },
    magenta: {
      "100": "#fdd0ec",
      "200": "#f797d2",
      "300": "#e774bb",
      "400": "#da62ac",
      "500": "#cd519d",
      "600": "#ae4787",
      "700": "#943d73",
      "800": "#50253f",
      "900": "#421f34",
      "000": "#ffecf8",
    },
    lime: {
      "100": "#d3f1a7",
      "200": "#b3df72",
      "300": "#94c748",
      "400": "#82b536",
      "500": "#6a9a23",
      "600": "#5b7f24",
      "700": "#4c6b1f",
      "800": "#37471f",
      "900": "#2a3818",
      "000": "#eefbda",
    },
  },
  text: {
    default: "#172b4d",
    subtle: "#44546f",
    subtlest: "#626f86",
    disabled: "#8590a2",
    inverse: "#ffffff",
    brand: "#0c66e4",
    selected: "#0c66e4",
    danger: "#ae2a19",
    success: "#216e4e",
    discovery: "#5e4db2",
    information: "#0055cc",
    accent: {
      blue: {
        default: "#0055cc",
        bolder: "#09326c",
      },
      red: {
        default: "#ae2a19",
        bolder: "#601e16",
      },
      orange: {
        default: "#974f0c",
        bolder: "#5f3811",
      },
      yellow: {
        default: "#7f5f01",
        bolder: "#533f04",
      },
      green: {
        default: "#216e4e",
        bolder: "#164b35",
      },
      purple: {
        default: "#5e4db2",
        bolder: "#352c63",
      },
      teal: {
        default: "#206b74",
        bolder: "#1d474c",
      },
      magenta: {
        default: "#943d73",
        bolder: "#50253f",
      },
      gray: {
        default: "#44546f",
        bolder: "#091e42",
      },
      lime: {
        default: "#4c6b1f",
        bolder: "#37471f",
      },
    },
    warning: {
      default: "#974f0c",
      inverse: "#172b4d",
    },
  },
  icon: {
    default: "#44546f",
    subtle: "#626f86",
    inverse: "#ffffff",
    disabled: "#8590a2",
    brand: "#0c66e4",
    selected: "#0c66e4",
    danger: "#e34935",
    success: "#22a06b",
    discovery: "#8270db",
    information: "#1d7afc",
    accent: {
      blue: "#1d7afc",
      red: "#e34935",
      orange: "#d97008",
      yellow: "#b38600",
      green: "#22a06b",
      purple: "#8270db",
      teal: "#1d9aaa",
      magenta: "#cd519d",
      gray: "#758195",
      lime: "#6a9a23",
    },
    warning: {
      default: "#d97008",
      inverse: "#172b4d",
    },
  },
  border: {
    default: "#091e4224",
    inverse: "#ffffff",
    focused: "#388bff",
    input: "#091e4224",
    disabled: "#091e420f",
    brand: "#0c66e4",
    selected: "#0c66e4",
    danger: "#e34935",
    warning: "#d97008",
    success: "#22a06b",
    discovery: "#8270db",
    information: "#1d7afc",
    subtle: "#091e420f",
    accent: {
      blue: "#1d7afc",
      red: "#e34935",
      orange: "#d97008",
      yellow: "#b38600",
      green: "#22a06b",
      purple: "#8270db",
      teal: "#1d9aaa",
      magenta: "#cd519d",
      gray: "#758195",
    },
    table: {
      default: "#091e4224",
    },
  },
  background: {
    disabled: "#f1f2f4",
    accent: {
      blue: {
        subtlest: "#e9f2ff",
        subtler: "#cce0ff",
        subtle: "#579dff",
        bolder: "#0c66e4",
      },
      red: {
        subtlest: "#ffedeb",
        subtler: "#ffd2cc",
        subtle: "#f87462",
        bolder: "#ca3521",
      },
      orange: {
        subtlest: "#fff4e5",
        subtler: "#ffe2bd",
        subtle: "#faa53d",
        bolder: "#b65c02",
      },
      yellow: {
        subtlest: "#fff7d6",
        subtler: "#f8e6a0",
        subtle: "#e2b203",
        bolder: "#946f00",
      },
      green: {
        subtlest: "#dffcf0",
        subtler: "#baf3db",
        subtle: "#4bce97",
        bolder: "#1f845a",
      },
      teal: {
        subtlest: "#e3fafc",
        subtler: "#c1f0f5",
        subtle: "#60c6d2",
        bolder: "#1d7f8c",
      },
      purple: {
        subtlest: "#f3f0ff",
        subtler: "#dfd8fd",
        subtle: "#9f8fef",
        bolder: "#6e5dc6",
      },
      magenta: {
        subtlest: "#ffecf8",
        subtler: "#fdd0ec",
        subtle: "#e774bb",
        bolder: "#ae4787",
      },
      gray: {
        subtlest: "#f1f2f4",
        subtler: "#dcdfe4",
        subtle: "#8590a2",
        bolder: "#626f86",
      },
      lime: {
        subtlest: "#eefbda",
        subtler: "#d3f1a7",
        subtle: "#94c748",
        bolder: "#5b7f24",
      },
    },
    inverse: {
      subtle: {
        default: "#00000029",
        hovered: "#0000003d",
        pressed: "#00000052",
      },
    },
    input: {
      default: "#ffffff",
      hovered: "#f7f8f9",
      pressed: "#ffffff",
    },
    neutral: {
      default: {
        "[default]": "#091e420f",
        hovered: "#091e4224",
        pressed: "#091e4224",
      },
      subtle: {
        default: "#00000000",
        hovered: "#091e420f",
        pressed: "#091e4224",
      },
      bold: {
        default: "#44546f",
        hovered: "#2c3e5d",
        pressed: "#172b4d",
      },
    },
    brand: {
      bold: {
        default: "#0c66e4",
        hovered: "#0055cc",
        pressed: "#09326c",
      },
    },
    selected: {
      default: {
        "[default]": "#e9f2ff",
        hovered: "#cce0ff",
        pressed: "#85b8ff",
      },
      bold: {
        default: "#0c66e4",
        hovered: "#0055cc",
        pressed: "#09326c",
      },
    },
    danger: {
      default: {
        "[default]": "#ffedeb",
        hovered: "#ffd2cc",
        pressed: "#ff9c8f",
      },
      bold: {
        default: "#ca3521",
        hovered: "#ae2a19",
        pressed: "#601e16",
      },
    },
    warning: {
      default: {
        "[default]": "#fff7d6",
        hovered: "#f8e6a0",
        pressed: "#f8e6a0",
      },
      bold: {
        default: "#e2b203",
        hovered: "#cf9f02",
        pressed: "#b38600",
      },
    },
    success: {
      default: {
        "[default]": "#dffcf0",
        hovered: "#baf3db",
        pressed: "#7ee2b8",
      },
      bold: {
        default: "#1f845a",
        hovered: "#216e4e",
        pressed: "#164b35",
      },
    },
    discovery: {
      default: {
        "[default]": "#f3f0ff",
        hovered: "#dfd8fd",
        pressed: "#b8acf6",
      },
      bold: {
        default: "#6e5dc6",
        hovered: "#5e4db2",
        pressed: "#352c63",
      },
    },
    information: {
      default: {
        "[default]": "#e9f2ff",
        hovered: "#cce0ff",
        pressed: "#85b8ff",
      },
      bold: {
        default: "#0c66e4",
        hovered: "#0055cc",
        pressed: "#09326c",
      },
    },
  },
  blanket: {
    default: "#091e427d",
    selected: "#388bff14",
    danger: "#ef5c4814",
  },
  interaction: {
    hovered: "#00000029",
    pressed: "#00000052",
  },
  skeleton: {
    default: "#091e420f",
    subtle: "#091e4208",
  },
  link: {
    default: "#0c66e4",
    pressed: "#0055cc",
    visited: "#5e4db2",
  },
  chart: {
    brand: {
      default: "#1d7afc",
      hovered: "#0c66e4",
    },
    neutral: {
      default: "#8590a2",
      hovered: "#758195",
    },
    success: {
      default: {
        "[default]": "#22a06b",
        hovered: "#1f845a",
      },
      bold: {
        default: "#216e4e",
        hovered: "#164b35",
      },
    },
    danger: {
      default: {
        "[default]": "#ef5c48",
        hovered: "#e34935",
      },
      bold: {
        default: "#ae2a19",
        hovered: "#601e16",
      },
    },
    warning: {
      default: {
        "[default]": "#b38600",
        hovered: "#946f00",
      },
      bold: {
        default: "#7f5f01",
        hovered: "#533f04",
      },
    },
    information: {
      default: {
        "[default]": "#388bff",
        hovered: "#1d7afc",
      },
      bold: {
        default: "#0055cc",
        hovered: "#09326c",
      },
    },
    discovery: {
      default: {
        "[default]": "#8f7ee7",
        hovered: "#8270db",
      },
      bold: {
        default: "#5e4db2",
        hovered: "#352c63",
      },
    },
    categorical: {
      "1": {
        default: "#1d9aaa",
        hovered: "#1d7f8c",
      },
      "2": {
        default: "#5e4db2",
        hovered: "#352c63",
      },
      "3": {
        default: "#d97008",
        hovered: "#b65c02",
      },
      "4": {
        default: "#943d73",
        hovered: "#50253f",
      },
      "5": {
        default: "#09326c",
        hovered: "#092957",
      },
      "6": {
        default: "#8f7ee7",
        hovered: "#8270db",
      },
      "7": {
        default: "#50253f",
        hovered: "#421f34",
      },
      "8": {
        default: "#974f0c",
        hovered: "#5f3811",
      },
    },
    blue: {
      bold: {
        default: "#388bff",
        hovered: "#1d7afc",
      },
      bolder: {
        default: "#1d7afc",
        hovered: "#0c66e4",
      },
      boldest: {
        default: "#0055cc",
        hovered: "#09326c",
      },
    },
    red: {
      bold: {
        default: "#ef5c48",
        hovered: "#e34935",
      },
      bolder: {
        default: "#e34935",
        hovered: "#ca3521",
      },
      boldest: {
        default: "#ae2a19",
        hovered: "#601e16",
      },
    },
    orange: {
      bold: {
        default: "#d97008",
        hovered: "#b65c02",
      },
      bolder: {
        default: "#b65c02",
        hovered: "#974f0c",
      },
      boldest: {
        default: "#974f0c",
        hovered: "#5f3811",
      },
    },
    yellow: {
      bold: {
        default: "#b38600",
        hovered: "#946f00",
      },
      bolder: {
        default: "#946f00",
        hovered: "#7f5f01",
      },
      boldest: {
        default: "#7f5f01",
        hovered: "#533f04",
      },
    },
    green: {
      bold: {
        default: "#22a06b",
        hovered: "#1f845a",
      },
      bolder: {
        default: "#1f845a",
        hovered: "#216e4e",
      },
      boldest: {
        default: "#216e4e",
        hovered: "#164b35",
      },
    },
    teal: {
      bold: {
        default: "#1d9aaa",
        hovered: "#1d7f8c",
      },
      bolder: {
        default: "#1d7f8c",
        hovered: "#206b74",
      },
      boldest: {
        default: "#206b74",
        hovered: "#1d474c",
      },
    },
    purple: {
      bold: {
        default: "#8f7ee7",
        hovered: "#8270db",
      },
      bolder: {
        default: "#8270db",
        hovered: "#6e5dc6",
      },
      boldest: {
        default: "#5e4db2",
        hovered: "#352c63",
      },
    },
    magenta: {
      bold: {
        default: "#da62ac",
        hovered: "#cd519d",
      },
      bolder: {
        default: "#cd519d",
        hovered: "#ae4787",
      },
      boldest: {
        default: "#943d73",
        hovered: "#50253f",
      },
    },
    gray: {
      bold: {
        default: "#8590a2",
        hovered: "#758195",
      },
      bolder: {
        default: "#758195",
        hovered: "#626f86",
      },
      boldest: {
        default: "#44546f",
        hovered: "#2c3e5d",
      },
    },
    lime: {
      bold: {
        default: "#6a9a23",
        hovered: "#5b7f24",
      },
      bolder: {
        default: "#5b7f24",
        hovered: "#4c6b1f",
      },
      boldest: {
        default: "#4c6b1f",
        hovered: "#37471f",
      },
    },
  },
  palette: {
    Blue100: "#e9f2ff",
    Blue200: "#cce0ff",
    Blue300: "#85b8ff",
    Blue400: "#579dff",
    Blue500: "#388bff",
    Blue600: "#1d7afc",
    Blue700: "#0c66e4",
    Blue800: "#0055cc",
    Blue900: "#09326c",
    Blue1000: "#092957",
    Red100: "#ffedeb",
    Red200: "#ffd2cc",
    Red300: "#ff9c8f",
    Red400: "#f87462",
    Red500: "#ef5c48",
    Red600: "#e34935",
    Red700: "#ca3521",
    Red800: "#ae2a19",
    Red900: "#601e16",
    Red1000: "#4f1c16",
    Yellow100: "#fff7d6",
    Yellow200: "#f8e6a0",
    Yellow300: "#f5cd47",
    Yellow400: "#e2b203",
    Yellow500: "#cf9f02",
    Yellow600: "#b38600",
    Yellow700: "#946f00",
    Yellow800: "#7f5f01",
    Yellow900: "#533f04",
    Yellow1000: "#3f3102",
    Green100: "#dffcf0",
    Green200: "#baf3db",
    Green300: "#7ee2b8",
    Green400: "#4bce97",
    Green500: "#2abb7f",
    Green600: "#22a06b",
    Green700: "#1f845a",
    Green800: "#216e4e",
    Green900: "#164b35",
    Green1000: "#143c2b",
    Purple100: "#f3f0ff",
    Purple200: "#dfd8fd",
    Purple300: "#b8acf6",
    Purple400: "#9f8fef",
    Purple500: "#8f7ee7",
    Purple600: "#8270db",
    Purple700: "#6e5dc6",
    Purple800: "#5e4db2",
    Purple900: "#352c63",
    Purple1000: "#15373b",
    Teal100: "#e3fafc",
    Teal200: "#c1f0f5",
    Teal300: "#8bdbe5",
    Teal400: "#60c6d2",
    Teal500: "#37b4c3",
    Teal600: "#1d9aaa",
    Teal700: "#1d7f8c",
    Teal800: "#206b74",
    Teal900: "#1d474c",
    Teal1000: "#153337",
    Orange100: "#fff4e5",
    Orange200: "#ffe2bd",
    Orange300: "#fec57b",
    Orange400: "#faa53d",
    Orange500: "#f18d13",
    Orange600: "#d97008",
    Orange700: "#b65c02",
    Orange800: "#974f0c",
    Orange900: "#5f3811",
    Orange1000: "#4a2b0f",
    Magenta100: "#ffecf8",
    Magenta200: "#fdd0ec",
    Magenta300: "#f797d2",
    Magenta400: "#e774bb",
    Magenta500: "#da62ac",
    Magenta600: "#cd519d",
    Magenta700: "#ae4787",
    Magenta800: "#943d73",
    Magenta900: "#50253f",
    Magenta1000: "#421f34",
    Lime100: "#eefbda",
    Lime200: "#d3f1a7",
    Lime300: "#b3df72",
    Lime400: "#94c748",
    Lime500: "#82b536",
    Lime600: "#6a9a23",
    Lime700: "#5b7f24",
    Lime800: "#4c6b1f",
    Lime900: "#37471f",
    Lime1000: "#2a3818",
    Neutral0: "#ffffff",
    Neutral100: "#f7f8f9",
    Neutral100A: "#091e4208",
    Neutral200: "#f1f2f4",
    Neutral200A: "#091e420f",
    Neutral300: "#dcdfe4",
    Neutral300A: "#091e4224",
    Neutral400: "#b3b9c4",
    Neutral400A: "#091e4224",
    Neutral500: "#8590a2",
    Neutral500A: "#091e427d",
    Neutral600: "#758195",
    Neutral700: "#626f86",
    Neutral800: "#44546f",
    Neutral900: "#2c3e5d",
    Neutral1000: "#172b4d",
    Neutral1100: "#091e42",
  },
  elevation: {
    surface: {
      default: {
        "[default]": "#ffffff",
        hovered: "#f1f2f4",
        pressed: "#dcdfe4",
      },
      sunken: "#f7f8f9",
      raised: {
        default: "#ffffff",
        hovered: "#f1f2f4",
        pressed: "#dcdfe4",
      },
      overlay: {
        default: "#ffffff",
        hovered: "#f1f2f4",
        pressed: "#dcdfe4",
      },
    },
    shadow: {
      raised: [
        {
          color: "#091e4240",
          type: "dropShadow",
          x: 0,
          y: 1,
          blur: 1,
          spread: 0,
        },
        {
          color: "#091e424f",
          type: "dropShadow",
          x: 0,
          y: 0,
          blur: 1,
          spread: 0,
        },
      ],
      overflow: {
        default: [
          {
            color: "#0304048f",
            type: "dropShadow",
            x: 0,
            y: 0,
            blur: 12,
            spread: 0,
          },
          {
            color: "#03040480",
            type: "dropShadow",
            x: 0,
            y: 0,
            blur: 1,
            spread: 0,
          },
        ],
        spread: "#091e4229",
        perimeter: "#091e421f",
      },
      overlay: [
        {
          color: "#091e4226",
          type: "dropShadow",
          x: 0,
          y: 8,
          blur: 12,
          spread: 0,
        },
        {
          color: "#091e424f",
          type: "dropShadow",
          x: 0,
          y: 0,
          blur: 1,
          spread: 0,
        },
      ],
    },
  },
};
